import React from 'react';
import AssistantBotRow from '../shells/AssistantBotRow';
import UserReplyRow from '../shells/UserReplyRow';
import { safetyRulesBubbleText, stepQuestionKey } from './preEmploymentEducationSteps';
import type { usePreEmploymentEducationFlow } from './usePreEmploymentEducationFlow';

type Flow = ReturnType<typeof usePreEmploymentEducationFlow>;

function isYes(raw: string): boolean {
  const v = raw.trim().toLowerCase();
  return v === 'yes' || v === 'true';
}

export default function PreEmploymentEducationChatThread({ flow }: { flow: Flow }) {
  const {
    t,
    committed,
    isComplete,
    materialsDeclined,
    currentStep,
    assistantQuestionVisible,
    showSafetyRulesBlock,
  } = flow;
  const undoLabel = t('submitDocuments.chat.undo');
  const editLabel = t('submitDocuments.fillFormsChecklist.edit');

  const materialsDone = committed.some((c) => c.stepId === 'materialsUnderstood');
  const materialsYes = committed.some((c) => c.stepId === 'materialsUnderstood' && isYes(c.rawValue));
  const agreeDone = committed.some((c) => c.stepId === 'agree');

  return (
    <>
      {committed.map((c, i) => (
        <React.Fragment key={`${c.stepId}-${i}`}>
          {c.stepId === 'agree' && showSafetyRulesBlock && (
            <AssistantBotRow animateIn>{safetyRulesBubbleText(t)}</AssistantBotRow>
          )}
          {c.stepId === 'materialsUnderstood' && (
            <AssistantBotRow animateIn>{t(stepQuestionKey('materialsUnderstood'))}</AssistantBotRow>
          )}
          <UserReplyRow
            displayText={c.displayText}
            showEdit={flow.showEditForCommitIndex(i)}
            onEdit={() => flow.jumpToEditCommitIndex(i)}
            editLabel={editLabel}
            showUndo={flow.showUndoForCommitIndex(i)}
            onUndo={flow.undo}
            undoLabel={undoLabel}
          />
        </React.Fragment>
      ))}

      {materialsDeclined && (
        <AssistantBotRow animateIn>{t('submitDocuments.preEmploymentEducation.notUnderstoodMessage')}</AssistantBotRow>
      )}

      {!isComplete && !materialsDeclined && currentStep && assistantQuestionVisible && (
        <>
          {currentStep.stepId === 'materialsUnderstood' && !materialsDone && (
            <AssistantBotRow animateIn>{t(stepQuestionKey('materialsUnderstood'))}</AssistantBotRow>
          )}
          {currentStep.stepId === 'agree' && materialsYes && !agreeDone && (
            <AssistantBotRow animateIn>{safetyRulesBubbleText(t)}</AssistantBotRow>
          )}
        </>
      )}
    </>
  );
}
